import { AuthService } from '@auth0/auth0-angular';
import { AdminAuthService } from '../services/auth/admin-auth.service';

/**
 * Single safe logout path shared by every "Log out" entry point.
 *
 * clearAdminTenantInfo() touches localStorage/sessionStorage, which can throw
 * (SecurityError in private mode, blocked storage, quota). It MUST NOT be able
 * to prevent the Auth0 logout — otherwise a thrown cleanup leaves an
 * authenticated session alive on a shared device. The try/finally guarantees
 * auth.logout() always runs.
 */
export function performLogout(auth: AuthService, adminAuth: AdminAuthService): void {
  try {
    adminAuth.clearAdminTenantInfo();
  } finally {
    // #1257 — return to THIS app's own origin after logout, not Auth0's default
    // (which sent customers to the calendar app). Each app's origin must be in
    // Auth0 "Allowed Logout URLs". Mirrors the operator app's signOut().
    auth.logout({ logoutParams: { returnTo: window.location.origin }, openUrl: url => location.replace(url) });
  }
}
